import { render, staticRenderFns } from "./formatcurrency.vue?vue&type=template&id=a3531aa4&"
import script from "./formatcurrency.vue?vue&type=script&lang=js&"
export * from "./formatcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3531aa4')) {
      api.createRecord('a3531aa4', component.options)
    } else {
      api.reload('a3531aa4', component.options)
    }
    module.hot.accept("./formatcurrency.vue?vue&type=template&id=a3531aa4&", function () {
      api.rerender('a3531aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EutfZZV2ZFlk/JS/formatcurrency.vue"
export default component.exports